import { useFeatureQuery } from '@common/hooks';
import { InitialQueryState, SkipOrArgs } from '@common/types/queryState';
import { useAuthentication } from '@features/authentication';
import { skipToken } from '@reduxjs/toolkit/query';
import { useMemo } from 'react';
import { useGetAccountsQuery } from '../api';
import { GetAccountsArgs } from '../types';

export const useAccounts = (initialArgs: InitialQueryState = {}) => {
    const {
        id: userId,
        isLoading: isUserDataLoading,
        isError: isUserDataError,
    } = useAuthentication();

    const queryArgs: SkipOrArgs<GetAccountsArgs> = useMemo(() => {
        if (!userId) return skipToken;
        return { userId };
    }, [userId]);

    const {
        isLoading: isAccountsLoading,
        isError: isAccoutnsError,
        ...queryResult
    } = useFeatureQuery(initialArgs, useGetAccountsQuery, queryArgs);

    return {
        ...queryResult,
        isLoading: isAccountsLoading || isUserDataLoading,
        isError: isAccoutnsError || isUserDataError,
    };
};
